// extracted by mini-css-extract-plugin
export default {"product":"ProductContent_product__bHMyy"};